import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const savePncInformation = (tableValues) => apiActionCreator({
  'endpoint': '/part-number-code',
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PNC_RECORDS_REQUEST,
    [
      {'type': ActionTypes.SAVE_PNC_RECORDS_SUCCESS},
      (response) => buildSuccessMessage(response, 'Información subida satisfactoriamente'),
    ],
    [
      ActionTypes.SAVE_PNC_RECORDS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': tableValues,
});
